/** True when thread title indicates Life Music / song production workflow. */
export function isSongProductionThread(title: string | null | undefined): boolean {
  if (!title?.trim()) return false;
  return /\b(song|suno|lyric|album|worship|music production|life music|viral spiritual|album-to-suno)\b/i.test(
    title
  );
}
